import { __awaiter } from "tslib";
import { contactAdapter } from './adapters';
import AjaxUtils from './ajaxUtils';
const fetchContactsList = (listKey_1, ...args_1) => __awaiter(void 0, [listKey_1, ...args_1], void 0, function* (listKey, queryParams = '') {
    const listKeyParam = listKey === 'all contacts' ? '' : `/${listKey}`;
    const results = yield AjaxUtils.get(`/api/v1/contacts${listKeyParam}?${queryParams}`);
    return results === null || results === void 0 ? void 0 : results.contacts.map(contact => contactAdapter(contact, results.maskId));
});
export { fetchContactsList };
